import { Buffer } from "buffer";

const isEmpty = (item: any) => {
  return !item || item === null || item === undefined || item === "" || item.length === 0;
};

/** dataURL을 받아서 Blob으로 변환한 파일을 리턴한다. */
const dataUrlToBlob = (dataURL: string, fileName?: string) => {
  const blobBin = Buffer.from(dataURL.split(",")[1], "base64");
  const array = [];
  for (let i = 0; i < blobBin.length; i++) {
    array.push(blobBin[i]);
  }
  const file = new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  const fileWithName = new File([file], fileName ? fileName : "Blob", {
    type: "image/jpeg",
  });
  return fileWithName;
};

const formattedDate = (date: Date) => {
  const time = date.getTime();
  const offset = date.getTimezoneOffset() * 60000;
  const isoString = new Date(time - offset).toISOString().split("T")[0];
  return isoString.split("T")[0].replaceAll("-", ".");
};

const getFormattedDate = (milliseconds: number): string => {
  const date = new Date(milliseconds);
  const offset = date.getTimezoneOffset() * 60000;
  const isoString = new Date(milliseconds - offset).toISOString();
  return isoString.split("T")[0].replaceAll("-", ".");
};

const getFormattedDateTime = (milliseconds: number): string => {
  const date = new Date(milliseconds);
  const offset = date.getTimezoneOffset() * 60000;
  const isoString = new Date(milliseconds - offset).toISOString();
  const formattedDate = isoString.split("T")[0].replaceAll("-", ".");
  const formattedTime = isoString.split("T")[1].split(".")[0];
  return formattedDate + " " + formattedTime;
};

const getWorkingDateTime = (milliseconds: number): string => {
  const currSec = 1000;
  const currMin = 60 * 1000;
  const currHour = 60 * 60 * 1000;
  const currDay = 24 * 60 * 60 * 1000;
  let workingDateTime = "0";
  if(milliseconds / currHour >= 24) {
    workingDateTime = Math.round(milliseconds / currDay) + " 일";
  } else if (milliseconds / currMin > 60) {
    workingDateTime = Math.round(milliseconds / currHour) + " 시간";
  } else if (milliseconds / currSec > 60) {
    workingDateTime = Math.round(milliseconds / currMin) + " 분";
  } else {
    workingDateTime = Math.round(milliseconds / currSec) + " 초";
  }
  return workingDateTime;
};

/** 오늘날짜를 milliseconds로 반환 */
const getTodayMillisecondsDate = (): number => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
};

/** 이번달 1일 milliseconds로 반환 */
const getFirstDayOfCurrentMonthMillisecondsDate = (): number => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1).getTime();
};

/** 몇 개월 전 후 오늘을 milliseconds로 반환
 * @param aMonth 전후 개월 수 (한달전이면 -1, 두달후면 2)
 */
const getTodayOfAMonthMillisecondsDate = (aMonth: number) => {
  const now = new Date();
  return new Date(
    now.getFullYear(),
    now.getMonth() + aMonth,
    now.getDate()
  ).getTime();
};

/** 이번달 며칠 전 후 오늘을 milliseconds로 반환
 * @param aDay 전후 일 수 (하루전이면 -1, 일주일전이면 -6, 하루후면 1)
 */
const getADayOfCurrentMonthMillisecondsDate = (aDay: number) => {
  const now = new Date();
  return new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + aDay
  ).getTime();
};

/** 글자 수 20자 넘어가면 ... 으로 표현하기
 * @param str 줄일 string
 * @limit 제한 글자 수 (기본 20)
 */
const truncate = (str: string, limit = 20) => {
  return str.length > limit ? str.substring(0, limit - 3) + "..." : str;
};

/*
  폰트 사이즈 계산 
*/

const allUnits = {
	px: {
		value: 'px',
		label: 'px',
		step: 1,
	},
	rem: {
		value: 'rem',
		label: 'rem',
		step: 0.01,
	},
};

const UNITS = Object.values(allUnits);

const parseUnit = (value: string): [string, string, number] => {
	const num = value.replace('px', '').replace('rem', '');

	const unitMatches = value.match(/[\d.\-+]*\s*(.*)/);
	const unit = unitMatches !== null ? unitMatches[1] : '';
	const match = UNITS.find((item) => item.value === unit);

	return [num, match?.value || 'px', match?.step || 1];
}

const convertToRem = (value: string, root: number): number => {
	const [num, unit] = parseUnit(value);

	if (unit === 'rem') {
		return parseFloat(num);
	}

	return parseFloat(num) / root;
}

const toFixed = (value: number) => {
	return parseFloat(value.toFixed(4));
}

const convertFontSize = (minFont: number, maxFont: number, screen: string = "pc") => {
  let minW: number = 350, maxW: number = 1920;
  if(screen === "mobile") {
    minW = 350;
    maxW = 768;
  } else if (screen === "tablet") {
    minW = 768;
    maxW = 1024;
  } else if (screen === "pc") {
    minW = 1024;
    maxW = 1920;
  }
  // console.log("convert: ", `${screen} - ${minW}, ${maxW}`);

  const root = parseInt("16px", 10);

	const minFontSize = convertToRem(`${minFont}px`, root);
	const maxFontSize = convertToRem(`${maxFont}px`, root);
	const minWidth = convertToRem(`${minW}px`, root);
	const maxWidth = convertToRem(`${maxW}px`, root);

  const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth);
	const yAxisIntersection = toFixed(-minWidth * slope + minFontSize);

	const min = `${minFontSize}rem`;
	const max = `${maxFontSize}rem`;
	const preferred = `${yAxisIntersection}rem + ${toFixed(slope * 100)}vw`;
  // return {
  //   min: min,
  //   max: max,
  //   value: preferred,
  // };
  return `clamp(${min}, ${preferred}, ${max})`;
};

const downloadFile = (path: string, fileName: string) => {
  // const filePath = path + "/" + fileName;
  // const a = document.createElement('a');
  // a.href = filePath;
  // a.download = fileName; // 다운로드될 파일 이름 설정
  // a.click();

  fetch(path + "/" + fileName).then(response => { 
    response.blob().then(blob => { 
      // Creating new object of PDF file 
      const fileURL = window.URL.createObjectURL(blob); 
      // Setting various property values 
      const alink = document.createElement('a'); 
      alink.href = fileURL; 
      alink.download = fileName; 
      alink.click(); 
      alink.remove();
    }) 
}) 
};

const openFile = (path: string, fileName: string) => {
  fetch(path + "/" + fileName).then(response => { 
    response.blob().then(blob => { 
      const fileURL = window.URL.createObjectURL(blob); 
      window.open(fileURL, "file");
    }) 
}) 
};

// const downloadURLFile = (data: any, fileName: string) => {
//   const file = new Blob([data], {
//     type: 'text/plain',
//   });
//   // 다운로드 링크 생성
//   const a = document.createElement('a');
//   a.href = window.URL.createObjectURL(file);
//   a.download = fileName; // 다운로드될 파일 이름 설정

//   document.body.appendChild(a); // FireFox
//   // 다운로드 링크를 클릭하여 파일 다운로드 시작
//   a.click();

//   window.URL.revokeObjectURL(a.href);
//   document.body.removeChild(a);
//   a.remove();
// };

export {
  isEmpty,
  dataUrlToBlob,
  getFormattedDate,
  formattedDate,
  getFormattedDateTime,
  getWorkingDateTime,
  getTodayMillisecondsDate,
  getFirstDayOfCurrentMonthMillisecondsDate,
  getTodayOfAMonthMillisecondsDate,
  getADayOfCurrentMonthMillisecondsDate,
  truncate,
  convertFontSize,
  downloadFile,
  openFile,
};